import { render } from "./rich-text-display.vue?vue&type=template&id=4f21e09a"
import script from "./rich-text-display.vue?vue&type=script&lang=js"
export * from "./rich-text-display.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__